import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import {
	WidgetNames,
	DashboardParamsApi,
	DashboardData,
	WidgetData,
	MOTIVATION_TYPES,
} from 'Pages/dashboard'
import { Id } from 'Types/aliases'

export async function getDashBoardDataApi(
	params: Pick<DashboardParamsApi, 'partner_id' | 'period' | 'from' | 'to'>
) {
	const res = await axiosDS().get<Pick<DashboardData, 'manager' | 'partner' | 'widgets'>>(
		urls.root.dashboard.data,
		{
			params,
		}
	)
	return res.data
}

export async function getWidgetDataApi(widgetName: WidgetNames, params: DashboardParamsApi) {
	const res = await axiosDS().get<WidgetData | { error: string }>(
		`${urls.root.dashboard.widget}/${widgetName}`,
		{
			params,
		}
	)
	return res.data
}

type ResponseAvailableProducts = {
	available_products: Record<number, string>
}
export async function getAvailableProductsApi(
	params: Omit<DashboardParamsApi, 'full' | 'products_ids'>
) {
	const res = await axiosDS().get<ResponseAvailableProducts>(
		urls.root.dashboard.availableProducts,
		{
			params,
		}
	)
	return res.data
}

export async function updateMotivationWidgetApi(id: Id, motivation: MOTIVATION_TYPES) {
	const res = await axiosDS().patch(
		`${urls.pp.partner.update_motivation.replace(':id', id.toString())}`,
		{
			data: { motivation },
		}
	)
	return res.data
}
